import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { DollarFormat, RatioFormat } from '../../format';
import OperatingRatiosByLOBRowData from './OperatingRatiosByLOBRowData';
import RowHelmet from '../RowHelmet';
import styles from './OperatingRatiosByLOBRow.module.css';
import { DataResult } from '../../model/DataResult';

function rowClassSwitch(rowClass: string = '') {
  switch (rowClass) {
    case 'TOTAL':
      return styles.total;
    default:
      return '';
  }
}
function hasAnyOutsideBenchmarks(
  medicalLossRatioCurrentYear: DataResult,
  adminExpsenseRatioCurrentYear: DataResult,
  combinedRatioCurrentYear: DataResult,
  underWritingGLCurrentYear: DataResult
) {
  return (
    medicalLossRatioCurrentYear?.outsideBenchmark ||
    adminExpsenseRatioCurrentYear?.outsideBenchmark ||
    combinedRatioCurrentYear?.outsideBenchmark ||
    underWritingGLCurrentYear?.outsideBenchmark
  );
}

export default function OperatingRatiosByLOBRow({
  sectionKey,
  rowKey,
  rowClass,
  label,
  benchmark,
  mlIndustryAverage,
  medicalLossRatioCurrentYear,
  medicalLossRatioPriorYear,
  aeIndustryAverage,
  adminExpsenseRatioCurrentYear,
  adminExpsenseRatioPriorYear,
  crIndustryAverage,
  combinedRatioCurrentYear,
  combinedRatioPriorYear,
  underWritingGLCurrentYear,
  underWritingGLPriorYear,
  rowDisplay
}: OperatingRatiosByLOBRowData) {
  const {
    showBenchmark,
    showIndustryMean,
    riskRepository
  }: { readonly showBenchmark: boolean; showIndustryMean: boolean; riskRepository: string } = useContext(AppContext);
  const id = `${sectionKey}-${rowKey}`;
  const isGrey = getDataDisplayType(rowDisplay, riskRepository);

  return (
    <div
      id={id}
      data-testid={id}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${
        !isGrey ? '' : styles.grey
      } ${rowClassSwitch(rowClass)}`}>
      <RowHelmet
        label={label}
        isOutsideBenchmark={hasAnyOutsideBenchmarks(
          medicalLossRatioCurrentYear,
          adminExpsenseRatioCurrentYear,
          combinedRatioCurrentYear,
          underWritingGLCurrentYear
        )}
        benchmarkText={benchmark}
      />
      {showIndustryMean && mlIndustryAverage?.value != null ? <RatioFormat {...mlIndustryAverage} /> : <p></p>}
      <RatioFormat {...medicalLossRatioCurrentYear} />
      <RatioFormat {...medicalLossRatioPriorYear} />
      {showIndustryMean && aeIndustryAverage?.value != null ? <RatioFormat {...aeIndustryAverage} /> : <p></p>}
      <RatioFormat {...adminExpsenseRatioCurrentYear} />
      <RatioFormat {...adminExpsenseRatioPriorYear} />
      {showIndustryMean && crIndustryAverage?.value != null ? <RatioFormat {...crIndustryAverage} /> : <p></p>}
      <RatioFormat {...combinedRatioCurrentYear} />
      <RatioFormat {...combinedRatioPriorYear} />
      <DollarFormat {...underWritingGLCurrentYear} />
      <DollarFormat {...underWritingGLPriorYear} />
    </div>
  );
}

function getDataDisplayType(
  rowDisplay:
    | {
        cr: string;
        lg: string;
        lq: string;
        mk: string;
        op: string;
        pu: string;
        rp: string;
        rv: string;
        st: string;
        fs: string;
      }
    | undefined,
  riskRepository: any
) {
  if (riskRepository === 'FR' || !rowDisplay) {
    return false;
  }
  if (
    riskRepository &&
    rowDisplay[riskRepository.toLowerCase() as keyof typeof rowDisplay] === 'GREY'
  ) {
    return true;
  }
}
